export const GET_POS_RATE_LIST_ACTION = "GET_POS_RATE_LIST_ACTION"
export const GET_POS_RATE_LIST_SUCCESS = "GET_POS_RATE_LIST_SUCCESS"

export const POS_RATE_SAVE_ACTION = "POS_RATE_SAVE_ACTION"
export const POS_RATE_SAVE_SUCCESS = "POS_RATE_SAVE_SUCCESS"


export const POS_RATE_API_ERROR_ACTION = "POS_RATE_API_ERROR_ACTION"